import React from 'react';
import { FavoriteStar } from '../../../../std/UI';
/**
 * Фильтр категории таблицы доп росписи
 */
export const CategoriesFilter = (props) => <div className='g-a-c-cont clearfix'>
      {props.categoriesData.map(([categoryID, state]) => <div key={`category_${categoryID}`} className={`g-a-c-i noselect ${state.isSelected ? 'g-a-c-i-s' : ''} ${state.isDisabled ? 'disabled' : ''} `} onClick={() => {
            !state.isDisabled && props.onSelect(state.matchId, [categoryID], !state.isSelected);
        }}>
            {props.onFavorite && <FavoriteStar isFavorite={!!state.isFavorite} onClick={(e) => {
                e.stopPropagation();
                props.onFavorite && props.onFavorite([categoryID], !state.isFavorite);
            }}/>}
            <span>{props.toLocale(state.label || categoryID)}</span>
            {typeof state[props.width] !== 'undefined' && <span className='g-a-c-i-t-c'>{state[props.width]}</span>}
         </div>)}
      {props.onFoldAllTables &&
        <a className='toogle-tables fl_r' onClick={() => {
                props.onFoldAllTables && props.onFoldAllTables(!props.isAllUnfolded);
            }}>
            <span className='control-panel-text'>
               {props.toLocale(props.isAllUnfolded ? 'COLLAPSE_ALL' : 'EXPAND_ALL')}
            </span>
         </a>}
   </div>;



// WEBPACK FOOTER //
// ./src/web-frontend-components/line/outcomes/additional/categories/Filter.jsx